import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-returned-books-list',
  templateUrl: './returned-books-list.component.html',
  styleUrls: ['./returned-books-list.component.css']
})
export class ReturnedBooksListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
